import { accountTypes } from '../actions/types';

const initialState = {
    unique_name: null,
    fullName: null,
    roles: null,
    dynamicsId: null,
    salesData: [],
    isLoggedIn: false,
    exp: 0,
    invalidToken: false,
}

export const accountReducer =
    (
        state = initialState,
        action
    ) => {
        switch (action.type) {
            case accountTypes.LOGIN:
                return {
                    ...state,
                    ...action.payload,
                    isLoggedIn: true,
                    invalidToken: false,
                };
            case accountTypes.CHANGE_DYNAMICS_ID:
                return {
                    ...state,
                    dynamicsId:action.payload.customer.customerNumber,
                    unique_name:action.payload.customer.customerName,
                    fullName:action.payload.customer.customerName,
                    roles: action.payload.customer.roles,
                    salesData: action.payload.salesData
                };
            case accountTypes.REMOVE_CUSTOMER_ID:
                return {
                    ...state,
                    ...action.payload,
                    salesData:[]
                }
            case accountTypes.LOGOUT:
                return {
                    ...initialState,
                }
            case accountTypes.INVALID_TOKEN:
                return {
                    ...state,
                    invalidToken: true,
                }
            default:
                return state;
        }
    };